<template>
  <app-dropdown
    placeholder="Filter by User Status"
    track-by="id"
    label="label"
    :options="statusSelection"
    v-bind="attrs"
    @on-selected="onUserStatusSelected"
    @on-removed="onUserStatusRemoved"
  />
</template>

<script>
import AppDropdown from "../AppComponents/AppDropdown.vue";

/**
 * The value that indicates that selecting this from the
 * dropdown means the user is trying to select all
 * user statuss.
 */
export const UserStatusListAllOption = {
  id: "all",
  label: "All User Statuses"
};

export default {
  components: {
    AppDropdown
  },
  computed: {
    // The rest of the attributes
    attrs() {
      const { placeholder, options, ...rest } = this.$attrs;
      return rest;
    },
    // Holds the data for the user status selection to be displayed
    statusSelection() {
      return [
        UserStatusListAllOption,
        {
          id: 1,
          label: "Active"
        },
        {
          id: 0,
          label: "Inactive"
        },
      ];
    }
  },
  methods: {
    onUserStatusSelected(props) {
      this.$emit("on-user-status-selected", props);
    },
    onUserStatusRemoved(props) {
      this.$emit("on-user-status-removed", props);
    }
  },
  inheritAttrs: false
};
</script>
